import React from 'react';

interface AlertBoxProps {
  type?: 'error' | 'success' | 'info' | 'warning';
  message: string;
  onClose?: () => void;
}

const colorScheme = {
  error: 'bg-red-50 border border-red-300 text-red-700',
  success: 'bg-green-50 border border-green-300 text-green-700',
  info: 'bg-blue-50 border border-blue-300 text-blue-700',
  warning: 'bg-yellow-50 border border-yellow-300 text-yellow-700',
};

const AlertBox: React.FC<AlertBoxProps> = ({ type = 'info', message, onClose }) => (
  <div className={`flex items-center px-4 py-3 rounded-lg text-sm mb-2 ${colorScheme[type]}`}>
    <span className="flex-1">{message}</span>
    {onClose && (
      <button
        className="ml-4 text-lg text-gray-400 hover:text-gray-700 focus:outline-none"
        onClick={onClose}
        aria-label="Close"
      >
        &times;
      </button>
    )}
  </div>
);

export default AlertBox;
